import React from 'react'
import styled, { css } from 'styled-components'
import { color } from '../styles'
import { SPACING } from '../styles/mixins/constants'
import { text } from '../styles/mixins/text'
import { Label } from './Label'
import { Spacer } from './Spacer'
import { insertTestingSelector, TestingKey } from '../util/testing'

export type LabelPosition = 'vertical' | 'horizontal'

export type InputContainerProps = {
    disabled: boolean
    errorMessage?: string
    hasDanger?: boolean
    label?: string
    labelPosition?: LabelPosition
    children: JSX.Element | JSX.Element[]
    className?: string
    testingKey?: TestingKey
}
export const InputContainer = (props: InputContainerProps): JSX.Element => {
    const {
        children,
        disabled,
        label,
        hasDanger,
        errorMessage = '',
        labelPosition = 'vertical',
        className,
        testingKey,
    } = props
    const errorSelector = testingKey ? insertTestingSelector(testingKey, 'error') : {}
    const labelSelector = testingKey ? insertTestingSelector(testingKey, 'label') : {}
    const Error = <ErrorMessage {...errorSelector}>{disabled ? '' : errorMessage}</ErrorMessage>
    return (
        <Container
            disabled={disabled}
            className={className}
            labelPosition={labelPosition}
            {...labelSelector}
        >
            {label && (
                <>
                    <StyledLabel hasError={!disabled && hasDanger} {...labelSelector}>
                        {label}
                        &#58;
                    </StyledLabel>
                    <Spacer
                        size={labelPosition === 'vertical' ? 1 : 2}
                        vertical={labelPosition === 'vertical'}
                    />
                </>
            )}

            <Content>
                {children}
                {errorMessage ? Error : null}
            </Content>
        </Container>
    )
}

const Container = styled.div<{
    disabled: boolean
    labelPosition: LabelPosition
}>`
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    position: relative;
    flex: 1 1 auto;
    min-height: 0px;
    min-width: 0px;
    width: 100%;
    ${(p) =>
        p.labelPosition === 'horizontal'
            ? css`
                  flex-flow: row nowrap;
                  align-items: center;
              `
            : ''}
    ${(p) =>
        p.labelPosition === 'vertical'
            ? css`
                  flex-flow: column nowrap;
                  align-items: flex-start;
              `
            : ''}
    && .ant-picker-input input {
        ${(p) =>
            p.disabled
                ? css`
                      background-color: ${color.background.muted};
                  `
                : ''}
    }
`

const ErrorMessage = styled.div`
    ${text('sub')}
    margin-top: ${SPACING[1]};
    flex-wrap: nowrap;
    && {
        color: ${color.status.danger};
    }
`

const Content = styled.div`
    width: 100%;
    position: relative;
`

const StyledLabel = styled(Label)`
    white-space: nowrap;
`

InputContainer.Content = Content
InputContainer.Container = Container
